import { VStack } from '@chakra-ui/react';
import { Field } from '@/components/ui/field';
import RolePicker from '@/components/services/role/RolePicker';
import { ContactFormFields, type ContactFormController } from '@/components/services/contact/ContactForm';

interface ProviderContactFieldsProps {
	controller: ContactFormController;
	selectedCategoryCode: string;
	onCategoryChange: (categoryCode: string) => void;
	px?: number;
	/** Bottom padding, which the host sets to meet its own action row: see the body's `pt`. */
	pb?: number | Record<string, number>;
	/** Opens the folded details; a change of key repeats the request. */
	moreDetailsOpenRequest?: number;
}

/** The Contact tab's body: the service the contact is added under, then their details. */
const ProviderContactFields = (props: ProviderContactFieldsProps) => {
	const { controller, selectedCategoryCode, onCategoryChange, px = 5, pb = 0, moreDetailsOpenRequest } = props;
	const { houseId } = controller;

	return (
		<VStack gap={4} align="stretch" px={px} pt={4} pb={pb}>
			<Field label="Service" required>
				<RolePicker
					houseId={houseId}
					value={selectedCategoryCode}
					placeholder="What do they do?"
					canEdit
					onChange={(role) => onCategoryChange(role.code)}
				/>
			</Field>

			<ContactFormFields controller={controller} moreDetailsOpenRequest={moreDetailsOpenRequest} />
		</VStack>
	);
};

export default ProviderContactFields;
